import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { RobotoUserConfigKey } from "../ConfigRecords";

import * as GetUserConfig from "./useUserConfig";

export function useUpdateUserConfig() {
  const queryClient = useQueryClient();
  const { configService } = useDomainServices();

  return useMutation({
    mutationFn: async ({
      key,
      value,
    }: {
      key: RobotoUserConfigKey;
      value: string;
    }) => {
      return configService.setUserConfig(key, value);
    },
    onSuccess: (_, { key, value }) => {
      return queryClient.setQueryData(GetUserConfig.getQueryKey(key), value);
    },
  });
}
